const s = Array.isArray, t = (r) => typeof r == "string" || r instanceof String;
export {
  s as a,
  t as i
};
//# sourceMappingURL=typed.J9F93ogK.js.map
